export default __webpack_public_path__ + "static/img37h-e18fb5b447d112afe13903cb73a6bbbd.jpg";